export default __webpack_public_path__ + "f4b06da30359359fd6c8de26589a2e91.png";